var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6975D247-0256-4A1C-A176-C15EA3CA320F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REIS_Wiregrame-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REIS_Reports-(Success-Example)-",
    transform: "translate(-390.000000, -438.000000)",
    fill: "#78BE20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal-Window/Check-Box-+-CTA/Checkbox-+-CTA",
    transform: "translate(357.000000, 346.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Success/Filled/30",
    transform: "translate(33.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C6.71625,0 0,6.71625 0,15 C0,23.28375 6.71625,30 15,30 C23.28375,30 30,23.28375 30,15 C30,6.71625 23.28375,0 15,0 Z M22.7129076,11.8297458 L13.32857,20.9540646 C13.0952029,21.1809657 12.779909,21.3076923 12.4509607,21.3076923 C12.1220123,21.3076923 11.8054772,21.1809657 11.5733513,20.9540646 L7.2870924,16.7865682 C6.80173843,16.3146623 6.80173843,15.5518885 7.2870924,15.0799826 C7.77244636,14.6080767 8.55695712,14.6080767 9.04231109,15.0799826 L12.4509607,18.3941863 L20.9576889,10.1231602 C21.4430429,9.65125429 22.2275536,9.65125429 22.7129076,10.1231602 C23.1982616,10.5950661 23.1982616,11.3578399 22.7129076,11.8297458 Z",
    id: "Icon/Success"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Success.198cdbbc1696697c730db032a48489a8.svg";